// The Product Sales Dashboard guide (05_UnitSalesDashboard.jsx · ModuleHelp, Max 01/11).
const en = {
  boardT: 'The sales board',
  boardB: 'This is the unit-sales dashboard, shown straight from Superset. It signs you in by itself, so there is nothing to log in to.',
  useT: 'Reading it',
  useB: 'Scroll inside the board to see every chart, and use the filters on the board to narrow what you look at. If your portal session runs out, you are sent back to the sign-in page.',
};
const ko = {
  boardT: '판매 보드',
  boardB: 'Superset의 판매 수량 대시보드가 그대로 표시됩니다. 자동으로 로그인되므로 따로 로그인할 필요가 없습니다.',
  useT: '보는 방법',
  useB: '보드 안에서 스크롤하면 모든 차트를 볼 수 있고, 보드의 필터로 보고 싶은 범위를 좁힐 수 있습니다. 포털 세션이 끝나면 로그인 화면으로 이동합니다.',
};
const vi = {
  boardT: 'Bảng doanh số',
  boardB: 'Đây là dashboard số lượng bán lấy trực tiếp từ Superset. Hệ thống tự đăng nhập giúp bạn nên không cần đăng nhập thêm.',
  useT: 'Cách xem',
  useB: 'Cuộn trong bảng để xem hết các biểu đồ, và dùng bộ lọc trên bảng để thu hẹp phạm vi cần xem. Nếu phiên portal hết hạn, bạn sẽ được đưa về trang đăng nhập.',
};
const zh = {
  boardT: '销售看板',
  boardB: '这里直接显示来自 Superset 的销量看板。系统会自动登录，您无需另外登录。',
  useT: '查看方法',
  useB: '在看板内滚动即可查看所有图表，并可用看板上的筛选器缩小查看范围。如果门户会话过期，您会被带回登录页面。',
};

// French and Japanese (task #1173, 2026-11-04) — generated from `en`; a string not yet translated reads English.
const fr = {
  "boardT": "Le tableau des ventes",
  "boardB": "Il s'agit du tableau de bord des ventes en unités, affiché directement depuis Superset. Il vous connecte automatiquement, il n'y a donc rien à saisir pour vous connecter.",
  "useT": "Le lire",
  "useB": "Faites défiler le tableau pour voir tous les graphiques, et utilisez les filtres du tableau pour affiner ce que vous regardez. Si votre session du portail expire, vous êtes renvoyé vers la page de connexion."
};
const ja = {
  "boardT": "売上ボード",
  "boardB": "数量ベースの売上ダッシュボードで、Superset から直接表示されます。自動的にサインインされるため、ログインは不要です。",
  "useT": "見方",
  "useB": "ボード内をスクロールしてすべてのグラフを確認し、ボード上のフィルターで表示内容を絞り込みます。ポータルのセッションが切れると、サインインページに戻ります。"
};

const dictionary = { ns: 'tourUnitSales', en, ko, vi, zh, fr, ja };
export default dictionary;
